// Atlas — a third surface, beside classic iot-admin and V2.
//
// WHY IT IS SEPARATE. Classic is the operator's console and V2 is its
// successor; both are organised around the estate — queues, registries, the
// thing that needs a human right now. Atlas is organised around the BUSINESS,
// in the order its questions are actually asked, and it is deliberately not
// bound to V2's design system: V2 is a cool-neutral operations console and this
// is not an operations console. Founder, 2026-09-19: "a different UIUX all
// together outside iot-admin v2 … this time the information would be structured
// in my way … it is a greenfield in UIUX".
//
// Styling is scoped under .atlas the way V2 scopes under .ggv2, so three design
// systems can share one bundle without reaching into each other. It shares
// exactly one thing with the others: services/api.js.

import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';

import Calendar from './pages/Calendar';
import CalendarV2 from './pages/CalendarV2';
import Unit from './pages/Unit';
import './atlas.css';

// The running order of the account. One page today; the rest are named here as
// they are agreed, so the shell shows where the story is going rather than
// pretending it is complete.
const PAGES = [
  { path: '/atlas', end: true, label: 'Deployment', blurb: 'When each screen went in, and what was live that day' },
  { path: '/atlas/v2', label: 'Deployment V2', blurb: 'The same day, briefed — a peer, not a replacement' },
  { path: '/atlas/unit', label: 'Unit Economics', blurb: 'What one screen earns in a month, and who keeps it' },
];

export default function AtlasApp() {
  return (
    <div className="atlas">
      <header className="atlasBar">
        <div className="atlasBarInner">
          {/* The one pDOOH.ai logotype. COPY LAW, from galigali-in's BrandLockup:
              the mark, then "pDOOH" in the display face at 700 with a GOLD
              ".ai" — never a grey one, and never the word without the mark. */}
          <span className="atlasMark" role="img" aria-label="pDOOH.ai Atlas">
            <img src="/pdooh-mark.png" alt="" className="atlasMarkImg" />
            <span className="atlasMarkWord">pDOOH<span className="atlasMarkAi">.ai</span></span>
          </span>
          <nav className="atlasNav">
            {PAGES.map((p) => (
              <NavLink
                key={p.path}
                to={p.path}
                end={p.end}
                className={({ isActive }) => `atlasNavLink${isActive ? ' isActive' : ''}`}
              >
                {p.label}
              </NavLink>
            ))}
          </nav>
          <a className="atlasEscape" href="/v2">Console</a>
        </div>
      </header>

      <main className="atlasMain">
        <Routes>
          <Route index element={<Calendar />} />
          <Route path="v2" element={<CalendarV2 />} />
          <Route path="unit" element={<Unit />} />
          <Route path="*" element={<Calendar />} />
        </Routes>
      </main>
    </div>
  );
}
